import http from "@/http-common";

/**
 * Service quản lý Gói Học Phí (Package)
 * Base URL: /web/receipt/v1/packages
 * Lưu ý: idSchool / idCreated / idModified KHÔNG cần truyền – BE tự xác định qua JWT token.
 */
class PackageManagementService {
  /**
   * Tìm kiếm danh sách gói học phí có phân trang (A-Z theo tên)
   * @param {Object} params - { keyword, billingCycle, autoRenew, page, size }
   */
  search(params) {
    return http.get("receipt/v1/packages", { params });
  }

  /**
   * Lấy toàn bộ danh sách gói học phí (không phân trang, dùng cho dropdown/select)
   */
  getAll() {
    return http.get("receipt/v1/packages/all");
  }

  /**
   * Lấy chi tiết một gói học phí theo ID
   * @param {number} id - ID gói học phí
   */
  findById(id) {
    return http.get(`receipt/v1/packages/${id}`);
  }

  /**
   * Tạo mới gói học phí
   * @param {Object} data - { name, description, billingCycle, cycleDuration, autoRenew, renewalNoticeDays, renewalReminderFrequencyDays, maxMembers }
   */
  create(data) {
    return http.post("receipt/v1/packages", data);
  }

  /**
   * Cập nhật gói học phí
   * @param {number} id - ID gói học phí
   * @param {Object} data - { name, description, billingCycle, cycleDuration, autoRenew, renewalNoticeDays, renewalReminderFrequencyDays, maxMembers }
   */
  update(id, data) {
    return http.put(`receipt/v1/packages/${id}`, data);
  }

  /**
   * Xóa mềm gói học phí
   * @param {number} id - ID gói học phí
   */
  remove(id) {
    return http.delete(`receipt/v1/packages/${id}`);
  }
}

export default new PackageManagementService();
